import Login from "@/views/Login.vue";
import Register from "@/views/Register.vue";
import Terms from "@/views/Terms.vue";
import NewsPublic from "@/views/news/NewsPublic.vue";
import Article from "@/views/news/Article.vue";

const routes = [
    {
        path: "/login",
        name: "Login",
        component: Login,
        meta: {
            onlyLoggedOut: true
        }
    },
    {
        path: "/register",
        name: "Register",
        component: Register,
        meta: {
            onlyLoggedOut: true
        }
    },
    {
        path: "/terms",
        name: "Terms",
        component: Terms,
        meta: {
            onlyLoggedOut: false
        }
    },
    {
        path: "/news-public",
        name: "NewsPublic",
        component: NewsPublic
    },
    { path: '*', redirect: '/login' }
]

export default routes.map(route => {
    const meta = {
        ...route.meta || {},
        requiresAuth: false
    }
    return { ...route, meta }
})